import { useEffect } from 'react';
import { useRecents, type RecentEntry, type RecentType } from './useRecents';

interface Props {
  type: RecentType;
  id: string | undefined;
  label: string | undefined;
  subtitle?: string;
  path: string;
}

export function TrackRecent({ type, id, label, subtitle, path }: Props) {
  const { addRecent } = useRecents();

  useEffect(() => {
    if (!id || !label) return;
    const entry: RecentEntry = {
      type,
      id,
      label,
      subtitle,
      path,
      visitedAt: Date.now(),
    };
    addRecent(entry);
  }, [type, id, label, subtitle, path, addRecent]);

  return null;
}
